import React from "react"
import { Card, CardBody, CardTitle, Table, Alert } from "reactstrap"
import { isEmpty } from "lodash"

const BirthDetails = ({ birthChart }) => {
  return (
    <Card>
      <CardBody>
        <CardTitle className="mb-4">
          <Alert color="info" className="mb-0" role="alert">
            Personal Details
          </Alert>
        </CardTitle>

        <div className="table-responsive">
          <Table className="table align-middle table-nowrap">
            <tbody className="font-size-14">
              <tr>
                <th scope="row">Name :</th>
                <td>{birthChart.name}{" "}</td>
              </tr>
              <tr>
                <th scope="row">Date of birth :</th>
                <td>{birthChart.dateOfBirth}{" "}</td>
              </tr>
              <tr>
                <th scope="row">Time of birth :</th>
                <td>{birthChart.timeOfBirth}{" "}</td>
              </tr>
              <tr>
                <th scope="row">Place of birth :</th>
                <td>{birthChart.placeOfBirth}{" "}</td>
              </tr>
              <tr>
                <th scope="row">Timezone :</th>
                <td> UTC difference {birthChart.timeZone / 60 }{" Hours "}</td>
              </tr>
              <tr>
                <th scope="row">Gender :</th>
                <td>{birthChart.gender}{" "}</td>
              </tr>
              {birthChart.refferedBy && (
                <tr>
                  <th scope="row">Reffered by :</th>
                  <td>{birthChart.refferedBy}{" "}</td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </CardBody>
    </Card>
  )
}

BirthDetails.propTypes = {

}

export default BirthDetails
